/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ApiTokenImport } from './routes/api-token'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'
import { Route as CustomerIndexImport } from './routes/customer/index'
import { Route as CustomerCreateImport } from './routes/customer/create'
import { Route as CustomerCustomerIdIndexImport } from './routes/customer/$customerId/index'
import { Route as CustomerCustomerIdCreateConfigurationTypeImport } from './routes/customer/$customerId/create/$configurationType'
import { Route as CustomerCustomerIdConfigurationConfigurationIdIndexImport } from './routes/customer/$customerId/configuration/$configurationId/index'
import { Route as CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeImport } from './routes/customer/$customerId/configuration/$configurationId/create/$configType'

// Create/Update Routes

const ApiTokenRoute = ApiTokenImport.update({
  id: '/api-token',
  path: '/api-token',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const CustomerIndexRoute = CustomerIndexImport.update({
  id: '/customer/',
  path: '/customer/',
  getParentRoute: () => rootRoute,
} as any)

const CustomerCreateRoute = CustomerCreateImport.update({
  id: '/customer/create',
  path: '/customer/create',
  getParentRoute: () => rootRoute,
} as any)

const CustomerCustomerIdIndexRoute = CustomerCustomerIdIndexImport.update({
  id: '/customer/$customerId/',
  path: '/customer/$customerId/',
  getParentRoute: () => rootRoute,
} as any)

const CustomerCustomerIdCreateConfigurationTypeRoute =
  CustomerCustomerIdCreateConfigurationTypeImport.update({
    id: '/customer/$customerId/create/$configurationType',
    path: '/customer/$customerId/create/$configurationType',
    getParentRoute: () => rootRoute,
  } as any)

const CustomerCustomerIdConfigurationConfigurationIdIndexRoute =
  CustomerCustomerIdConfigurationConfigurationIdIndexImport.update({
    id: '/customer/$customerId/configuration/$configurationId/',
    path: '/customer/$customerId/configuration/$configurationId/',
    getParentRoute: () => rootRoute,
  } as any)

const CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeRoute =
  CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeImport.update({
    id: '/customer/$customerId/configuration/$configurationId/create/$configType',
    path: '/customer/$customerId/configuration/$configurationId/create/$configType',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/api-token': {
      id: '/api-token'
      path: '/api-token'
      fullPath: '/api-token'
      preLoaderRoute: typeof ApiTokenImport
      parentRoute: typeof rootRoute
    }
    '/customer/create': {
      id: '/customer/create'
      path: '/customer/create'
      fullPath: '/customer/create'
      preLoaderRoute: typeof CustomerCreateImport
      parentRoute: typeof rootRoute
    }
    '/customer/': {
      id: '/customer/'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof CustomerIndexImport
      parentRoute: typeof rootRoute
    }
    '/customer/$customerId/': {
      id: '/customer/$customerId/'
      path: '/customer/$customerId'
      fullPath: '/customer/$customerId'
      preLoaderRoute: typeof CustomerCustomerIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/customer/$customerId/create/$configurationType': {
      id: '/customer/$customerId/create/$configurationType'
      path: '/customer/$customerId/create/$configurationType'
      fullPath: '/customer/$customerId/create/$configurationType'
      preLoaderRoute: typeof CustomerCustomerIdCreateConfigurationTypeImport
      parentRoute: typeof rootRoute
    }
    '/customer/$customerId/configuration/$configurationId/': {
      id: '/customer/$customerId/configuration/$configurationId/'
      path: '/customer/$customerId/configuration/$configurationId'
      fullPath: '/customer/$customerId/configuration/$configurationId'
      preLoaderRoute: typeof CustomerCustomerIdConfigurationConfigurationIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/customer/$customerId/configuration/$configurationId/create/$configType': {
      id: '/customer/$customerId/configuration/$configurationId/create/$configType'
      path: '/customer/$customerId/configuration/$configurationId/create/$configType'
      fullPath: '/customer/$customerId/configuration/$configurationId/create/$configType'
      preLoaderRoute: typeof CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/api-token': typeof ApiTokenRoute
  '/customer/create': typeof CustomerCreateRoute
  '/customer': typeof CustomerIndexRoute
  '/customer/$customerId': typeof CustomerCustomerIdIndexRoute
  '/customer/$customerId/create/$configurationType': typeof CustomerCustomerIdCreateConfigurationTypeRoute
  '/customer/$customerId/configuration/$configurationId': typeof CustomerCustomerIdConfigurationConfigurationIdIndexRoute
  '/customer/$customerId/configuration/$configurationId/create/$configType': typeof CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/api-token': typeof ApiTokenRoute
  '/customer/create': typeof CustomerCreateRoute
  '/customer': typeof CustomerIndexRoute
  '/customer/$customerId': typeof CustomerCustomerIdIndexRoute
  '/customer/$customerId/create/$configurationType': typeof CustomerCustomerIdCreateConfigurationTypeRoute
  '/customer/$customerId/configuration/$configurationId': typeof CustomerCustomerIdConfigurationConfigurationIdIndexRoute
  '/customer/$customerId/configuration/$configurationId/create/$configType': typeof CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/api-token': typeof ApiTokenRoute
  '/customer/create': typeof CustomerCreateRoute
  '/customer/': typeof CustomerIndexRoute
  '/customer/$customerId/': typeof CustomerCustomerIdIndexRoute
  '/customer/$customerId/create/$configurationType': typeof CustomerCustomerIdCreateConfigurationTypeRoute
  '/customer/$customerId/configuration/$configurationId/': typeof CustomerCustomerIdConfigurationConfigurationIdIndexRoute
  '/customer/$customerId/configuration/$configurationId/create/$configType': typeof CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/api-token'
    | '/customer/create'
    | '/customer'
    | '/customer/$customerId'
    | '/customer/$customerId/create/$configurationType'
    | '/customer/$customerId/configuration/$configurationId'
    | '/customer/$customerId/configuration/$configurationId/create/$configType'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/api-token'
    | '/customer/create'
    | '/customer'
    | '/customer/$customerId'
    | '/customer/$customerId/create/$configurationType'
    | '/customer/$customerId/configuration/$configurationId'
    | '/customer/$customerId/configuration/$configurationId/create/$configType'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/api-token'
    | '/customer/create'
    | '/customer/'
    | '/customer/$customerId/'
    | '/customer/$customerId/create/$configurationType'
    | '/customer/$customerId/configuration/$configurationId/'
    | '/customer/$customerId/configuration/$configurationId/create/$configType'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ApiTokenRoute: typeof ApiTokenRoute
  CustomerCreateRoute: typeof CustomerCreateRoute
  CustomerIndexRoute: typeof CustomerIndexRoute
  CustomerCustomerIdIndexRoute: typeof CustomerCustomerIdIndexRoute
  CustomerCustomerIdCreateConfigurationTypeRoute: typeof CustomerCustomerIdCreateConfigurationTypeRoute
  CustomerCustomerIdConfigurationConfigurationIdIndexRoute: typeof CustomerCustomerIdConfigurationConfigurationIdIndexRoute
  CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeRoute: typeof CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ApiTokenRoute: ApiTokenRoute,
  CustomerCreateRoute: CustomerCreateRoute,
  CustomerIndexRoute: CustomerIndexRoute,
  CustomerCustomerIdIndexRoute: CustomerCustomerIdIndexRoute,
  CustomerCustomerIdCreateConfigurationTypeRoute:
    CustomerCustomerIdCreateConfigurationTypeRoute,
  CustomerCustomerIdConfigurationConfigurationIdIndexRoute:
    CustomerCustomerIdConfigurationConfigurationIdIndexRoute,
  CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeRoute:
    CustomerCustomerIdConfigurationConfigurationIdCreateConfigTypeRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/api-token",
        "/customer/create",
        "/customer/",
        "/customer/$customerId/",
        "/customer/$customerId/create/$configurationType",
        "/customer/$customerId/configuration/$configurationId/",
        "/customer/$customerId/configuration/$configurationId/create/$configType"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/api-token": {
      "filePath": "api-token.tsx"
    },
    "/customer/create": {
      "filePath": "customer/create.tsx"
    },
    "/customer/": {
      "filePath": "customer/index.tsx"
    },
    "/customer/$customerId/": {
      "filePath": "customer/$customerId/index.tsx"
    },
    "/customer/$customerId/create/$configurationType": {
      "filePath": "customer/$customerId/create/$configurationType.tsx"
    },
    "/customer/$customerId/configuration/$configurationId/": {
      "filePath": "customer/$customerId/configuration/$configurationId/index.tsx"
    },
    "/customer/$customerId/configuration/$configurationId/create/$configType": {
      "filePath": "customer/$customerId/configuration/$configurationId/create/$configType.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
